/**
 * Reusable page loading component
 * Displays a centered loading spinner with optional message
 */

import React from 'react';

export interface PageLoadingProps {
  message?: string;
  className?: string;
  fullScreen?: boolean;
}

/**
 * Page loading component for displaying loading state
 *
 * @example
 * if (isLoading) {
 *   return <PageLoading message="데이터를 불러오는 중..." />;
 * }
 */
export const PageLoading: React.FC<PageLoadingProps> = ({
  message = '데이터를 불러오는 중...',
  className = '',
  fullScreen = false,
}) => {
  const containerClass = fullScreen
    ? 'teacher-page'
    : className || 'teacher-page';

  return (
    <div className={containerClass}>
      <div className="page-loading">
        <div className="loading-spinner"></div>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default PageLoading;
